<template>
  <DoughnutChart
    :chart-data="chartData"
    :options="options"
    :styles="styles"
  />
</template>

<script>
import { DoughnutChart } from '@/components/charts'
import { setCommas } from '@/utils/helpers.js'

export default {
  components: {
    DoughnutChart
  },
  props: {
    wholeData: {
      type: Number,
      required: true
    },
    partData: {
      type: Number,
      required: true
    }
  },
  data (vm) {
    return {
      colors: {},
      options: {
        responsive: true,
        legend: {
          labels: {
            boxWidth: 10,
            fontSize: 14
          },
          onClick () {}
        },
        tooltips: {
          callbacks: {
            label: ({ datasetIndex, index }, { labels }) => {
              if (datasetIndex === 1) return `総センサー数：${setCommas(this.wholeData)}`
              return labels[index]
            }
          }
        }
      }
    }
  },
  computed: {
    restData () {
      return this.wholeData - this.partData
    },
    chartData () {
      return {
        labels: [`センサー設置済み：${setCommas(this.partData)}`, `センサー未設置：${setCommas(this.restData)}`],
        datasets: [
          {
            data: [this.partData, this.restData],
            backgroundColor: [ 'blue', 'skyblue' ]
          },
          {
            data: [this.wholeData],
            backgroundColor: [ 'darkblue' ],
            weight: 0.4
          }
        ]
      }
    },
    styles () {
      return {
        height: '100%',
        width: '100%',
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
      }
    }
  }
}
</script>
